import { useEffect, useState } from 'react';
import ReportsApi from '../../../../API/shipment/reports-api';
import { MARKETS_ALL, TYPE_BUTTONS } from '../../../../constans';
import styles from './styles.module.scss';
import { PopUp, Row } from '../../../../components/Basic/Blocks';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import { DateInput, Input, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { Button } from '../../../../components/Basic/Buttons';

const SHOPS = {
  ozon: ['ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['megamarket1', 'megamarket2'],
  avito: ['avito1']
};

const REPORT_TYPE_MAP = {
  Основной: 'Основной',
  Выкупной: 'Выкупной',
};

const LIST_EXPRESS = [
  { name: 'Нет', value: false },
  { name: 'Да', value: true },
];
const CreateReportPopUp = ({ close = () => { } }) => {
  const [data, setData] = useState({
    period: {
      start: null,
      end: null,
    },
    info: '',
    market: '',
  });
  const [market, setMarket] = useState(Object.keys(MARKETS_ALL)[0]);
  const [shop, setShop] = useState();
  const [isExpress, setIsExpress] = useState({ name: 'Нет', value: false });
  const [shopName, setShopName] = useState('Все');
  const [reportType, setReportType] = useState('Основной');

  const validate = () => {
    return data.period.start && data.period.end;
  };

  const clickAdd = () => {
    if (validate()) {
      ReportsApi.createReport({
        data: {
          market: market.toLowerCase(),
          shop: shopName,
          period: data.period,
          reportIdWb: parseInt(data.reportIdWb),
          type: REPORT_TYPE_MAP[reportType],
        }
      })
        .then((r) => {
          close();
        });
    }
  };

  useEffect(() => {
    setMarket(Object.keys(MARKETS_ALL)[0]);
  }, []);

  useEffect(() => {
    if (market) {
      setShop(MARKETS_ALL[market][0]);
    }
    if (market === 'Sber' || market === 'Wb') {
      setIsExpress(LIST_EXPRESS[0]);
    }
  }, [market]);

  useEffect(() => {
    setShopName(SHOPS[market][0]);
  }, [market]);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>Добавить новую реализацию</H2>
      <Row>
        <Select
          list={Object.keys(MARKETS_ALL)}
          select={market}
          label="Площадка"
          onSelect={(v) => setMarket(v)}
          width={'150px'}
          style={{ marginRight: '15px' }}
        />
        <Select
          list={SHOPS[market] || []}
          select={shopName}
          label="Магазин"
          onSelect={(v) => setShopName(v)}
          width={'150px'}
          style={{ marginRight: '15px' }}
        />
      </Row>
      <Row className={styles.report}>
        <Select
          label="Тип отчета"
          select={reportType}
          list={['Основной', 'Выкупной']}
          onSelect={(v) => setReportType(v)}
          width="150px"
          style={{ marginRight: '15px' }}
        />
        <Input
          label="Номер отечета"
          value={data.reportIdWb}
          onChange={(v) => setData({ ...data, reportIdWb: parseInt(v) })}
        />
      </Row>

      <Row style={{ marginTop: '20px' }}>
        <InputLabel style={{ marginRight: '20px', width: '150px' }}>Дата начала периода</InputLabel>
        <DateInput onChange={(v) => setData({ ...data, period: { ...data.period, start: v } })} />
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <InputLabel style={{ marginRight: '20px', width: '150px' }}>Дата конца периода</InputLabel>
        <DateInput onChange={(v) => setData({ ...data, period: { ...data.period, end: v } })} />
      </Row>
      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          disabled={!data.period.start || !data.period.end}
          style={{
            marginRight: '15px',
          }}
          onClick={!data.period.start || !data.period.end ? () => { } : clickAdd}
        >
          Создать
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default CreateReportPopUp;
